/**
 * SVSideBar: 우측 사이드바 (참여자 목록 / 채팅 / 음성 / 초대).
 *
 * v1 원본: RenewalComponents/SVContent/Sidebar/SidebarPresenter.js
 *   <div className="sidebar new2">
 *     {openSideUser && <UserList />}
 *     {openSideChat && <Chat />}
 *     {openSideSpeech && <ChatHistory />}
 *     {openInviteUser && <InviteUser />}
 *   </div>
 *
 * v1에는 사이드바 내부에 탭바가 없다.
 * 각 하위 컴포넌트가 자체 헤더(.chat_tabs)와 닫기 버튼을 가진다.
 * 탭 전환은 Footer 버튼(참여자/채팅/대화기록)이 Redux로 전환.
 *
 * CSS 셀렉터 체인: .rtc_new3 .sidebar.new2 .new_chat ...
 */
import React from 'react';
import { useAppSelector } from '@/store/hooks';
import ParticipantList from './ParticipantList/ParticipantList';
import ChatArea from './ChatArea/ChatArea';
import SpeechSideBar from './SpeechSideBar/SpeechSideBar';
import InviteUser from './InviteUser/InviteUser';
import TranslationSideBar from './TranslationSideBar/TranslationSideBar';

interface SVSideBarProps {
  localUserId: string;
  onSendMessage: (message: string) => void;
  onKickParticipant?: (userId: string) => void;
  onGrantMaster?: (userId: string) => boolean | Promise<boolean>;
  onClearMaster?: (userId: string) => boolean | Promise<boolean>;
  onToggleAudio?: () => void;
  onToggleVideo?: () => void;
  onResponseJoinRequest?: (userId: string, status: 'allow' | 'deny') => void;
}

const SVSideBar: React.FC<SVSideBarProps> = ({
  localUserId,
  onSendMessage,
  onKickParticipant,
  onGrantMaster,
  onClearMaster,
  onToggleAudio,
  onToggleVideo,
  onResponseJoinRequest,
}) => {
  const ui = useAppSelector((s) => s.ui);
  const conference = useAppSelector((s) => s.conference);
  const { sidebarContent, openSideBar } = ui;

  // v1: SidebarPresenter — openSideBar false면 렌더링하지 않음
  if (!openSideBar) return null;

  return (
    <div className="sidebar new2 rtcCustoms_sidebar">
      {/* 참석자 */}
      {sidebarContent === 'participants' && (
        <ParticipantList
          localUserId={localUserId}
          maxParticipants={conference.maxParticipants}
          onKickParticipant={onKickParticipant}
          onGrantMaster={onGrantMaster}
          onClearMaster={onClearMaster}
          onToggleAudio={onToggleAudio}
          onToggleVideo={onToggleVideo}
          onResponseJoinRequest={onResponseJoinRequest}
        />
      )}
      {/* 채팅 */}
      {sidebarContent === 'chat' && <ChatArea onSendMessage={onSendMessage} />}
      {/* 대화기록 */}
      {sidebarContent === 'speech' && <SpeechSideBar />}
      {/* 초대 */}
      {sidebarContent === 'invite' && <InviteUser />}
      {/* 자막/번역 */}
      {sidebarContent === 'translation' && <TranslationSideBar />}
    </div>
  );
};

export default SVSideBar;
